import { isErpApiSuccess } from "../erpClient";
import { extractListRowsFromResponse } from "./parseApiPagination";

export function createGirviIdempotencyKey() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export const isGirviApiSuccess = (res) => isErpApiSuccess(res);

export function normalizeListGirvisRows(res) {
  if (!isGirviApiSuccess(res)) return [];
  const arr = extractListRowsFromResponse(res, ["girvis"]);

  return arr.map((g) => ({
    id: g.id ?? g.girvi_document_id ?? g.girvi_id,
    girvi_number: g.girvi_number ?? g.girvi_no ?? g.doc_number ?? "",
    girvi_date: g.girvi_date ?? g.doc_date ?? "",
    customer_name: g.customer_name ?? g.supplier_name ?? "",
    customer_mobile: g.customer_mobile ?? g.mobile ?? g.supplier_mobile ?? "",
    principal_given: g.principal_given ?? g.principal_amount ?? 0,
    remaining_amount: g.remaining_amount ?? g.remaining_amt ?? 0,
    interest_percent: g.interest_percent ?? 0,
    monthly_interest: g.monthly_interest ?? 0,
    due_date: g.due_date ?? g.expected_return ?? null,
    status: g.status ?? "",
    total_items: g.total_items ?? g.item_count ?? 0,
    // Keep original for UI fallbacks
    raw: g,
  }));
}

export function getGirviShowFirstObject(res) {
  if (!isGirviApiSuccess(res)) return null;
  const data = res?.data;
  if (Array.isArray(data)) return data[0] ?? null;
  if (data && typeof data === "object") return data;
  return null;
}

/** POST /api/girvi_bank type list */
export function normalizeGirviBanksListResponse(res) {
  if (!isGirviApiSuccess(res)) return [];
  const d = res.data;
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.records)) return d.records;
  if (Array.isArray(d?.banks)) return d.banks;
  if (Array.isArray(d?.data)) return d.data;
  return [];
}

export function normalizeGirviItems(items) {
  if (!Array.isArray(items)) return [];
  return items.map((it) => ({
    girvi_item_id: it.girvi_item_id ?? it.id ?? null,
    product_group_name: it.product_group_name ?? "",
    tag_no: it.tag_no ?? "",
    image: it.image ?? null,
    pcs: it.pcs ?? 0,
    gwt: it.gwt ?? 0,
    lwt: it.lwt ?? 0,
    nwt: it.nwt ?? 0,
    fine_wt: it.fine_wt ?? 0,
    purity: it.purity ?? "",
    rate_on: it.rate_on ?? "",
    rate: it.rate ?? 0,
    other_charges: it.other_charges ?? 0,
    totalamt: it.totalamt ?? it.total_amt ?? 0,
    mrp: it.mrp ?? 0,
    remarks: it.remarks ?? "",
    status: it.status ?? 1,
    raw: it,
  }));
}

